module.exports = __webpack_public_path__ + "static/media/dsr_apply.54c9127a.png";